import axiosClient from "./axiosClient";

const reportApi = {
  getOverview: (params) =>
    axiosClient.get("/api/reports/overview", { params }),
  getConversationVolume: (params) =>
    axiosClient.get("/api/reports/conversation-volume", { params }),
  getStaffLeaderboard: (params) =>
    axiosClient.get("/api/reports/staff-leaderboard", { params }),
  getUnresolved: (params) =>
    axiosClient.get("/api/reports/unresolved", { params }),
  getHeatmap: (params) => axiosClient.get("/api/reports/heatmap", { params }),
  getChatbotDelivery: (params) =>
    axiosClient.get("/api/reports/chatbot-delivery", { params }),
  getPipeline: (params) =>
    axiosClient.get("/api/reports/pipeline", { params }),
  getTags: (params) => axiosClient.get("/api/reports/tags", { params }),
};

export default reportApi;
